import { useId } from 'react';
import styled from 'styled-components';

import { unitMapping } from 'lib/style';

const AbsoluteSvg = styled.svg`
  position: absolute;
  bottom: 10%;
  right: 4%;
`;

type Props = {
  size?: keyof typeof unitMapping;
  status?: 'active' | 'inactive' | 'pending';
};
export const HeartIcon = ({ size = 2, status = 'inactive' }: Props) => {
  const fillId = useId();
  const filterId = useId();

  const fillByStatus = {
    active: (
      <radialGradient
        id={fillId}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.1488 41.694) scale(22.8755)"
      >
        <stop stopColor="#FEF314" />
        <stop offset="1" stopColor="#FF4E22" />
      </radialGradient>
    ),
    inactive: (
      <linearGradient
        id={fillId}
        x1="20"
        y1="0"
        x2="20"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.499104" stopColor="#0E0E0E" />
        <stop offset="1" stopColor="#FF2828" />
      </linearGradient>
    ),
    pending: (
      <radialGradient
        id={fillId}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.4518 25.4699) scale(9.15022)"
      >
        <stop stopColor="#FEF314" />
        <stop offset="1" stopColor="#FF4E22" />
      </radialGradient>
    ),
  };
  return (
    <div style={{ position: 'relative' }}>
      <svg
        style={{ width: unitMapping[size], height: unitMapping[size] }}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter={status === 'active' ? `url(#${filterId})` : undefined}>
          <path
            d="M39.25 6.29492V19.4238L19.9736 38.9316L0.75 19.4248V6.29492L10.0127 0.869141L19.6475 6.5127L20.0264 6.73535L20.4062 6.5127L30.0127 0.869141L39.25 6.29492Z"
            fill={`url(#${fillId})`}
            fillOpacity={status === 'active' ? 1 : 0.54}
            stroke="#FF7E34"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          {fillByStatus[status]}
          <filter
            id={filterId}
            x="-0.000112653"
            y="9.41753e-06"
            width="69.3078"
            height="69.3078"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1.48019"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_10673_120908"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.58686" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_10673_120908"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_10673_120908"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.95127" />
            <feGaussianBlur stdDeviation="1.11015" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect2_innerShadow_10673_120908"
            />
          </filter>
        </defs>
      </svg>
      {status === 'pending' && (
        <AbsoluteSvg
          style={{
            width: `calc(${size} * var(--half-unit))`,
            height: `calc(${size} * var(--half-unit))`,
          }}
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 3V2C2 0.89543 2.89543 0 4 0C5.10457 0 6 0.895431 6 2V3H7V8H1V3H2ZM3 2C3 1.44772 3.44772 1 4 1C4.55228 1 5 1.44772 5 2V3H3V2ZM3.5 6.5V4.5H4.5V6.5H3.5Z"
            fill="white"
          />
        </AbsoluteSvg>
      )}
    </div>
  );
};
